module.exports = __webpack_public_path__ + "img/pdf-badge.b221d05.svg";